// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"509":"bbd28d87","845":"bf43aada"}[chunkId] + ".chunk.css";
};